import * as signalR from '@microsoft/signalr';
import { Message } from '../types/user';
import { API_BASE } from '../api/config';

let connection: signalR.HubConnection | null = null;

// Serializes start/stop calls so a stop() can never call connection.stop()
// while a preceding start()'s handshake is still in flight (React StrictMode
// double-invokes this effect, which raced start() against stop() and
// produced "Handshake was canceled" errors).
let pending: Promise<void> = Promise.resolve();

export const startSignalRConnection = (onReceiveMessage: (message: Message) => void) => {
  pending = pending.then(async () => {
    if (connection && connection.state === signalR.HubConnectionState.Connected) {
      // Re-register the handler so the latest callback is always used
      connection.off('ReceiveMessage');
      connection.on('ReceiveMessage', onReceiveMessage);
      return;
    }

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(`${API_BASE}/chatHub`, {
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .build();

    conn.on('ReceiveMessage', onReceiveMessage);
    connection = conn;

    try {
      await conn.start();
      console.log('SignalR Connected!');
    } catch (err) {
      console.error('SignalR Connection Error: ', err);
    }
  });

  return pending.catch((err) => console.error('SignalR start error: ', err));
};

export const stopSignalRConnection = () => {
  pending = pending.then(async () => {
    const conn = connection;
    connection = null;
    if (conn) {
      try {
        await conn.stop();
      } catch (err) {
        console.error('SignalR stop error: ', err);
      }
    }
  });

  return pending.catch((err) => console.error('SignalR stop error: ', err));
};

export const getSignalRConnection = () => connection;
